import React from "react";
import Icon from "../atoms/Icon";
import SubNav from "../molecules/SubNav";
import SectionWrapper from "../SectionWrapper";

import {
  Box,
  Logo,
  Navbar,
  Wrapper,
  NavItem,
  SearchBox,
  SearchInput,
  NavContainer,
} from "./Navigation.styles";

const Navigation = () => {
  return (
    <Wrapper>
      <SubNav />
      <SectionWrapper bgColor="#fff" padding="10px 0">
        <NavContainer>
          <Logo href="/">Hekto</Logo>
          <Navbar>
            <NavItem className="current" to="/">
              Home
            </NavItem>
            <NavItem to="/home/pages">Pages</NavItem>
            <NavItem to="/">Products</NavItem>
            <NavItem to="/">Blog</NavItem>
            <NavItem to="/">Shop</NavItem>
            <NavItem to="/">Contact</NavItem>
          </Navbar>
          <SearchBox>
            <SearchInput />
            <Box>
              <Icon src="/svgs/search_icon.svg" alt="search" width={14} height={14} />
            </Box>
          </SearchBox>
        </NavContainer>
      </SectionWrapper>
    </Wrapper>
  );
};

export default Navigation;
